export default "__VITE_ASSET__X70pRjhe__"